import Backbone from '@polleverywhere/backbone'
import Check from './multi_step_login/check'
import AuthPassword from './multi_step_login/auth_password'
import AuthSaml from './multi_step_login/auth_saml'

const VIEW_STATE_TO_CLASS_MAP = {
  authPassword: AuthPassword,
  authSaml: AuthSaml,
  check: Check
}

function setViewState (state, viewState) {
  const ViewStateClass = VIEW_STATE_TO_CLASS_MAP[viewState]

  // Pass the result of the user check into the subcomponent
  const opts = Object.assign(this.state.pick('username', 'userCheck'), this.options)
  const newView = new ViewStateClass(opts)

  setCurrentView.call(this, newView)
}

function setCurrentView (newView) {
  removeCurrentView.call(this)

  this.currentView = newView
  this.currentView.on('all', this.trigger.bind(this))

  this.currentView.on('account:found', ({ username, userCheck }) => {
    const viewState = (userCheck.sso && userCheck.login_labels.length) ? 'authSaml' : 'authPassword'
    this.state.set({
      viewState,
      username,
      userCheck
    })
  })

  this.currentView.on('click:identity', () =>
    this.state.set({ viewState: 'check' })
  )

  this.currentView.on('click:use_password', () =>
    this.state.set({ viewState: 'authPassword' })
  )

  this.currentView.on('click:use_saml', () =>
    this.state.set({ viewState: 'authSaml' })
  )

  this.$el.append(this.currentView.render().$el)
}

function removeCurrentView () {
  this.currentView && this.currentView.remove()
}

/**
 * This component is used to manage a multi-step authentication workflow. It first
 * renders a check component to ensure that a user exists. It then passes that
 * found username and other authentication-related information into a component
 * that authenticates a Session model.
 *
 * It forwards all events that are triggered by the sub-components.
 */
export default class MultiStepLogin extends Backbone.View {
  get className () { return 'component-auth__multi-step-login' }
  get form () { return this.currentView.form }

  /**
   * @param {Object} options Configuration options.
   * @param {Object} options.model Session model we use for authentication, must provide 'authenticate' method
   * @param {Object} options.sso Sso configuration options - see /components/auth/sso/index for documentation
   * @param {Object} options.redux Set true to use the redux store
   */
  initialize (options = {}) {
    if (!options.redux && typeof options.model !== 'object') {
      throw new TypeError('Session model must be passed in')
    }

    this.options = options

    this.state = new Backbone.Model({
      viewState: null,
      userCheck: null
    })

    this.state.on('change:viewState', setViewState.bind(this))

    super.initialize()
  }

  render () {
    this.state.set('viewState', 'check')

    return this
  }

  remove () {
    removeCurrentView.call(this)
    super.remove()
  }
}
